﻿CrossingSearchBox = class {
    constructor(t, lineItemIds, discountCode) {
        this.target = t;
        this.form = this.target.querySelector("form");
        this.routeElement = this.target.querySelector("[name=route]");
        this.routeLargeSelect = this.target.querySelector("[data-select-type=list]");
        this.routeSelect = {};
        this.bookAgainDetails;
        this.target.querySelector("[name=discountCode]").value = discountCode;
        if (lineItemIds != null)
            {
            this.bookAgainDetails = this.getLineItemIdDetails(lineItemIds);
            }

        this.form.addEventListener("submit", this.submit.bind(this));
    }

    createPayload() {
        let passengerTypes = this.target.querySelectorAll("[name=passengerType]");
        let outboundDateValues = searchBoxes.dateTimes.getValues(this.getDateTimeContainer("Outbound"));
        let inboundDateValues = searchBoxes.dateTimes.getValues(this.getDateTimeContainer("Inbound"));

        return Promise.resolve({
            discountCode: this.form.discountCode.value,
            affiliate: this.form.Affiliate.value,
            route: this.form.route.value,
            searchType: this.target.querySelector("[name=searchType]:checked").value,
            outboundDate: outboundDateValues.date,
            outboundHour: outboundDateValues.hours,
            outboundMinute: outboundDateValues.minutes,
            inboundDate: inboundDateValues.date,
            inboundHour: inboundDateValues.hours,
            inboundMinute: inboundDateValues.minutes,
            passengers: [].filter
                .call(passengerTypes, element => element.value !== "0")
                .map(element => ({ id: element.dataset.id, value: element.value }))
        });
    }

    ValidateInfant(errors) {
        const infantId = document.querySelector("[data-infant-id]")?.dataset.infantId;
        const adultIds = document.querySelector("[data-adult-ids]")?.dataset.adultIds;

        if (!infantId || !adultIds) {
            return;
        }
        
        const infantAmount = searchBoxes.passengers.getSelectedForTypeId(this.form, infantId).value;
        const adultAmount = searchBoxes.passengers.getSelectedForTypeArrayId(this.form, adultIds.split(','))
            .map(passengerType => passengerType.value)
            .reduce((a, b) => parseInt(a) + parseInt(b), 0);
        
        if (infantAmount > 0 && adultAmount <= 0){
            const message = this.form.dataset.infantValidationMessage;
            errors.push(message);
        } 
    }
    
    ValidatePayload(search) {
        let errors = [];

        let outbound = searchBoxes.dateTimes.getValues(this.getDateTimeContainer("Outbound")).parsedDate();

        this.ValidateInfant(errors);
        
        if (!outbound) {
            errors.push("The departure date is invalid");
        } else if (outbound.isBefore(new moment())) {
            errors.push("The departure date cannot be before today's date.");
        }

        if (search.searchType === "return") {
            let inbound = searchBoxes.dateTimes.getValues(this.getDateTimeContainer("Inbound")).parsedDate();

            if (!inbound) {
                errors.push("The return date is invalid");
            }
            
            if (outbound && inbound) {       
                if (inbound.isBefore(outbound)) {
                    errors.push("The return date must be greater than the outbound date");
                } else if (inbound.isSame(outbound)) {
                    errors.push("Outbound and inbound date and time must be different");
                } else if (inbound.isBefore(new moment())) {
                    errors.push("The return date cannot be before today's date.");
                }
            }
        }

        if (search.passengers.length === 0) {
            errors.push("Please select at least 1 passenger.");
        }

        return errors;
    }

    ShowErrors(errors) {
        let area = this.target.querySelector(".search-form__validation-area");

        area.innerHTML = "";
        errors.forEach(error => {
                let message = document.createElement("p");
                message.innerText = error;
                area.appendChild(message);
            });

        area.style.display = area.innerHTML === "" ? "none" : "block";

        return errors;
    }

    CheckValidation() {
        this.createPayload()
            .then(payload => this.ValidatePayload(payload))
            .then(errors => this.ShowErrors(errors));
    }

    submit() {
        event.preventDefault();

        this.createPayload()
            .then(payload => {
                this.form.searchPayload.value = JSON.stringify(payload);
                localStorage.currentSearch = JSON.stringify(payload);
                localStorage.currentSearchType = "results";
                return payload;
            })
            .then(payload => this.ValidatePayload(payload))
            .then(errors => this.ShowErrors(errors))
            .then(errors => {
                if (!errors.length) {
                    this.form.submit();
                    Utilities.ShowLoader();
                }
            })
            .then(_ => {
                if (Modal.current !== null) {
                    Modal.close();
                }
            });
    }

    get(uri) {
        return window.fetch(uri).then(response => response.json());
    }
    
    getAffiliateId() {
        const affiliate = this.target.querySelector("#Affiliate");
        if(affiliate){
            return affiliate.value;
        }
        return null;
    }
    
    getAffiliateDefaultRoute() {
        var defaultRoute = document.querySelector("[data-default-route]");
        
        if (defaultRoute){
            return defaultRoute.dataset["defaultRoute"]
        }
        
        return "";
    }
    
    defaultRoute() {
        const affiliateDefaultRoute = this.getAffiliateDefaultRoute();
        if(affiliateDefaultRoute !== "" && affiliateDefaultRoute !== undefined){
            return affiliateDefaultRoute;
        } else {
            return this.get("/api/data/variables/B2CDefaultRoute");
        }
        
    }

    findById(array, id) {
        return array.find(item => item.Id === id);
    }

    getDepartureLocations() {
        return this.get("/api/data/DeparturePoints").then(data => data.filter(location => location.DeparturePoint));
    }

   
    
    getLineItemIdDetails(lineItemIds) {
        return window.fetch(`/api/data/GetBookAgainDetails`,
                {
                    method: "POST",
                    body: JSON.stringify(lineItemIds),
                    headers: { "Content-Type": "application/json" }
                })
            .then(response => response.json());
    }

        getRoutes(locations, selectedRoute) {
        return this.get("/api/data/routes").then(routes => {
            return routes
                .filter(route => this.findById(locations, route.DepartureId))
                .filter(route => this.findById(locations, route.DestinationId))
                .map(route => {
                    let value = `${route.DepartureId},${route.DestinationId}`;

                    return {
                        Departure: this.findById(locations, route.DepartureId),
                        Destination: this.findById(locations, route.DestinationId),
                        Value: value,
                        Selected: value === selectedRoute
                    };
                });
        });
    }

    addRouteOption(route, cb, context = this) {
        let text = `${route.Departure.Name} to ${route.Destination.Name}`;
        let dataValue = `${route.Departure.Name} <span class='icon'>→</span> ${
            route.Destination.Name
            }`;

        let option = new Option(text, route.Value, route.Selected);

        if (route.Selected) {
            context.routeElement.value = route.Value;
        }

        option.dataset["textvalue"] = dataValue;

        context.routeElement.appendChild(option);
        cb();
    }

    mapRoutes(selectedRoute) {
        return this.getDepartureLocations()
            .then(locations => this.getRoutes(locations, selectedRoute))
            .then(routes => routes.forEachAsync(this.addRouteOption, this)
                .then(_ => (this.routeElement.value = routes.find(x => x.Selected).Value))
            );
    }

    mapCrossing(route, type, direction) {
        let routeParts = route.split(",");
        let date = searchBoxes.dateTimes.getValues(this.getDateTimeContainer(direction)).parsedDate() || new moment();

        let url = `/api/data/crossings/${type}/${date.year()}/${date.month() +
            1}/${date.date()}/${date.hour()}/${date.minute()}/${routeParts[0]}/${
            routeParts[1]
            }`;

        return this.get(url).then(data => {
            let closestMatch = new moment(data.find(crossing => crossing.ClosestMatch).RobotDateTime);
            this.setDateTime(closestMatch, direction);
        });
    }

    removeEvents(el) {
        elClone = el.cloneNode(true);
        select = el.parentElement.querySelector("select");

        if (select) {
            select.disabled = true;
        }

        el.parentNode.replaceChild(elClone, el);
    }

    Initialise() {
        return Promise.resolve({})
            .then(_ => {
                this.renderDateTimePicker(this.getDateTimeContainer("Outbound"));
                this.renderDateTimePicker(this.getDateTimeContainer("Inbound"));
            })
            .then(_ => {
                if (this.bookAgainDetails != null) {
                    return this.bookAgainDetails
                        .then(object => object.Route);
                }
                return this.defaultRoute();
            } )
            .then(route => this.mapRoutes(route)
                .then(_ => this.loadCrossings(route)))
            .then(_ => {
                this.routeSelect = new LargeSelectList(this.routeLargeSelect);
                this.paxSelect = new LargeSelectPax(this.target.querySelector("[data-select-type=pax]"));

                this.target.querySelector("[data-loader]").remove();
                this.target.querySelector("form").style.display = "";

                Array.from(this.form.querySelectorAll(".type-select [data-type]"))
                    .forEach(elm => {
                        elm.addEventListener("click",
                            () => {
                                this.setTicketType(elm.dataset.type);
                            });
                    });
                this.form.outboundDate.addEventListener("change",
                    () =>
                    this.Update(this)
                );
                this.form.inboundDate.addEventListener("change",
                    () =>
                    this.Update(this)
                );
                this.form.route.addEventListener("change", () => this.Update(this));

                SearchBoxValidationCallback.addListener("Crossing",
                        () => {
                            this.CheckValidation();
                        });
            })
            .then(_ => {
                if (this.bookAgainDetails != null) {
                    this.bookAgainDetails
                        .then(bookAgainDetails => {
                            if (bookAgainDetails.Type != 20) {
                                setTicketType("oneway");
                            }
                            
                            let target = document.querySelectorAll(".search-form")[1];

                            this.removeTicketType(bookAgainDetails.Type, target);

                            this.setPassengers(JSON.parse(bookAgainDetails.Pax), target, bookAgainDetails.PaxTypes);

                            this.removeEvents(target.querySelector("#routeSelect"));
                            this.removeEvents(target.querySelector("[data-select-type='pax']"));

                            this.removeDownAngle(target.querySelector("#routeSelect"));
                            this.removeDownAngle(target.querySelector("[data-select-type='pax']"));

                        });
                }
            });
    }

    removeTicketType(type, target) {
        if (type == "oneway") {
            target.querySelector("[data-type='return']").remove();
        } else {
            target.querySelector("[data-type='oneway']").remove();
        }
    }

    removeDownAngle(el) {
        el.querySelector(".la-angle-down").remove();
    }

    setPassengers(paxJson, target, paxTypes) {
        var selectList = target.querySelector("[data-select-type='pax'] .large-select__value");
        selectList.innerText = "";
        paxJson.forEach(pax => {
            target.querySelector(`.pax-select [data-id='${pax.PassengerTypeId}']`).value = pax.PassengerCount;
            if (pax.PassengerCount > 0) {
                selectList.innerText = selectList.innerText.concat(`${pax.PassengerCount} ${paxTypes.find(x => x.Id == pax.PassengerTypeId).Name},`);
            }
        });
        selectList.innerText = selectList.innerText.slice(0, selectList.innerText.length - 1);

        selectList.innerText = selectList.innerText.split(',').join(', ');
    }

    Update(context) {
        let outboundDate = searchBoxes.dateTimes.getValues(context.getDateTimeContainer("Outbound")).parsedDate();
        let inboundDate = searchBoxes.dateTimes.getValues(context.getDateTimeContainer("Inbound")).parsedDate();

        if (outboundDate.isAfter(inboundDate)) {
            searchBoxes.dateTimes.setDateTime(context.getDateTimeContainer("Inbound"), outboundDate);
        }

        return context.loadCrossings(context.form.route.value)
        .then(_ => this.CheckValidation());
    }

    loadCrossings(route) {
        return Promise.all([
            this.mapCrossing(
                route,
                "forDay",
                "Outbound"
            ),
            this.mapCrossing(
                route
                .split(",")
                .reverse()
                .join(","),
                "endOfDay",
                "Inbound"
            )
        ]);
    }

    getDateTimeContainer(direction) {
        switch (direction) {
        case "Outbound":
            return this.form.querySelector(".direction-oneway");
        case "Inbound":
            return this.form.querySelector(".direction-return");
        default:
            throw "Unknown direction";
        }
    }

    setTicketType(ticketType) {
        let returnDirectionContainer = this.target.querySelector(".direction-return");

        if (ticketType == "return") {
            returnDirectionContainer.classList.remove("disabled");
        } else {
            returnDirectionContainer.classList.add("disabled");
        }

        this.target.querySelectorAll("[name=searchType]").forEach(elm => {
            elm.checked = elm.value == ticketType;
        });
    }

    bind(model) {
        return Promise.resolve({})
            .then(_ => searchBoxes.formWrappers.setSelectedValue(this.form.route, model.route))
            .then(_ => this.setTicketType(model.searchType))
            .then(_ => this.setDateTime(searchBoxes.dateTimes.buildUnixString(model.outboundDate, model.outboundHour, model.outboundMinute), "Outbound"))
            .then(_ => this.setDateTime(searchBoxes.dateTimes.buildUnixString(model.inboundDate, model.inboundHour, model.inboundMinute), "Inbound"))
            .then(_ => searchBoxes.passengers.setSelected(this.form, model.passengers));
    }

    setDateTime(d, direction) {
        if (typeof d === 'undefined') {
            d = new Date();
        }

        searchBoxes.dateTimes.setDateTime(this.getDateTimeContainer(direction), new moment(d));
    }

    renderDateTimePicker(container) {
        let datePicker = container.querySelector("[data-select-type='datetime-date']");
        let timePicker = container.querySelector("[data-select-type='datetime-time']");

        return [
            new LargeSelectDate(datePicker, datePicker.closest(".date-time-picker")),
            new LargeSelectTime(timePicker, timePicker.closest(".date-time-picker"))
        ];
    }
};

Array.prototype.forEachAsync = function (asyncFunction, context) {
    return this.reduce((promiseChain, item) => {
        return promiseChain.then(
            () =>
                new Promise(resolve => {
                    asyncFunction(item, resolve, context);
                })
        );
    }, Promise.resolve());
};